"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimit = exports.RateLimitProvider = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
// Represents a provider in rate limiting configuration
let RateLimitProvider = class RateLimitProvider {
    constructor(provider, request, limit, timeWindow, isDefault) {
        this.provider = provider;
        this.request = request;
        this.limit = limit;
        this.timeWindow = timeWindow;
        this.default = isDefault;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'provider' }),
    __metadata("design:type", String)
], RateLimitProvider.prototype, "provider", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'request' }),
    __metadata("design:type", String)
], RateLimitProvider.prototype, "request", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'limit' }),
    __metadata("design:type", String)
], RateLimitProvider.prototype, "limit", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'timeWindow' }),
    __metadata("design:type", String)
], RateLimitProvider.prototype, "timeWindow", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'default' }),
    __metadata("design:type", Boolean)
], RateLimitProvider.prototype, "default", void 0);
RateLimitProvider = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, String, String, String, Boolean])
], RateLimitProvider);
exports.RateLimitProvider = RateLimitProvider;
// Represents the rate limiting configuration for a single channel
let RateLimit = class RateLimit {
    constructor(channel, providers) {
        this.channel = channel;
        this.providers = providers;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'channel' }),
    __metadata("design:type", String)
], RateLimit.prototype, "channel", void 0);
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ name: 'providers', type: RateLimitProvider }),
    __metadata("design:type", Array)
], RateLimit.prototype, "providers", void 0);
RateLimit = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [String, Array])
], RateLimit);
exports.RateLimit = RateLimit;
